// owner/alerts/AlertsInvite.js — the overview card that explains alerts BEFORE the phone asks for permission
// (§4.5, consultant: "ask after sign-in, on the dashboard, with the benefit explained first"; §10 "8d").
// The store app only, and only while this phone has never been asked: «السماح» asks, then registers; «لاحقًا» hides
// the card until the next launch. Nothing is stored — an answered request is the phone's own permission state.

import React, { useState } from 'react';
import useLanguage from '../../hooks/useLanguage';
import Icon from '../ui/Icon';
import { useDeviceAlerts } from './deviceAlerts';

let laterThisLaunch = false;

const AlertsInvite = () => {
  const { t } = useLanguage();
  const device = useDeviceAlerts();
  const [later, setLater] = useState(laterThisLaunch);
  const [busy, setBusy] = useState(false);

  if (device.kind !== 'app' || device.status !== 'prompt' || later) return null;

  // The outcome shows in the channel's state (on / not allowed), which hides this card or keeps it; a failure leaves
  // it in place to try again, and settings says more.
  const allow = async () => {
    setBusy(true);
    try { await device.enable(); } catch (error) { /* stays offered */ } finally { setBusy(false); }
  };
  const notNow = () => { laterThisLaunch = true; setLater(true); };

  return (
    <section className="o-invite" aria-labelledby="alerts-invite-title">
      <span className="o-invite-glyph" aria-hidden="true"><Icon name="bell" /></span>
      <div className="o-body">
        <h2 id="alerts-invite-title">{t('ownerApp.alertsInvite.title')}</h2>
        <p>{t('ownerApp.alertsInvite.text')}</p>
        <div className="o-invite-actions">
          <button type="button" className="o-btn o-btn-primary" onClick={allow} disabled={busy}>
            {t('ownerApp.alertsInvite.allow')}
          </button>
          <button type="button" className="o-btn o-btn-ghost" onClick={notNow} disabled={busy}>
            {t('ownerApp.alertsInvite.later')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default AlertsInvite;
